module.exports = __webpack_public_path__ + "static/media/aleksey-little.153ca0cd.jpg";